import clsx from "clsx";
import { NavLink } from "react-router-dom";
import logo from "../assets/images/logoTwo.png";

const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/custom", label: "Custom Design" },
  { to: "/gallery", label: "Gallery" },
  { to: "/contact", label: "Contact" },
];

const NavBar = () => (
  <nav className="w-full flex mb-3 p-1 bg-riskcomfort-500 text-white">
    <div className="flex items-center">
      {NAV_LINKS.map(({ to, label }, index) => (
        <NavLink
          key={to}
          to={to}
          // Without `end`, "/" matches every route and is always active.
          end={to === "/"}
          className={clsx(
            "px-4 py-0 romanStandard",
            index === 0 && "lg:pl-20",
            // Dividers on every other link, as before.
            index % 2 === 1 && "border-x-2 border-white"
          )}
        >
          {label}
        </NavLink>
      ))}
    </div>
    <div className="hidden lg:block ml-auto w-[100px] p-2">
      <NavLink to="/" end aria-label="Motographic home">
        <img src={logo} alt="Motographic" />
      </NavLink>
    </div>
  </nav>
);

export default NavBar;
